export enum PaymentItemType {
    NotSet = 0,
    Invoice = 1,
    Account = 2
}
